import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setShowThankyouDialog = mutatorAction(
    'setShowThankyouDialog',
    (showThankyouDialog: boolean) => {
        let store = inlineFeedbackDialogStore();
        store.showThankyouDialog = showThankyouDialog;
    }
);
